import {
  BaseFieldWidget,
  DslDefinition,
  FormO2MTableFieldWidget,
  ModelFieldType,
  SPI,
  ViewType
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: [
      'deli.aries.seller.DeliAriesSellerPurchasingPlan',
      'deli.aries.seller.SellerDistributorTradeOrder',
      'deli.aries.merchant.DeliAriesBuyerPurchasingPlan'
    ],
    viewName: [
      '要货计划表单_FORM_uiVieweb96ec729ee645f4814835199ff94c0d',
      '经销要货计划表单_FORM_uiView5e21ad9d0bd746ac99ff7265ea450780'
    ],
    widget:'Table',
    viewType: ViewType.Form,
    ttype: ModelFieldType.OneToMany
  })
)
export class FormO2MTableUniqAdd extends FormO2MTableFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    return this;
  }

  public getDsl(): DslDefinition {
    // excludeItems里配一个不存在的字段就可以添加重复数据，具体去重逻辑在addSameData自定义动作中
    return { ...super.getDsl(), excludeItems: ['tradeDetailId'] };
  }
}
